import React from "react";
import "./DefaultImagingSettingRadioButton.css";

type Props = {
  name: string;
  label: string;
  checked: boolean;
  onChange: (name: string, value: boolean) => void;
  style: React.CSSProperties;
  disabled: boolean;
};

export default function DefaultImagingSettingRadioButton({ name, label, checked, onChange, style, disabled }: Props) {
  return (
    <div
      style={{
        marginTop: "10px",
        ...style,
      }}
    >
      <label className="container">
        {label}
        <input
          type="radio"
          name={name}
          onChange={(e) => onChange(name, e.target.checked)}
          checked={checked}
          disabled={disabled}
        />
        <span className="checkmark" />
      </label>
    </div>
  );
}
